import React, { useState } from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import TextAreaField from '../../../../Components/Form/components/TextAreaField';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import useNotification from '../../../../Hooks/useNotification.hook';
import useApiClient from '../../../Base/Hooks/useApiClient';
import Loading from '../../../../Components/Loading';
import {
	Document,
	useCancelP1MedicalRequestMutation,
} from '../../../../graphql/graphql';

interface Props {
	item: Document;
	onSuccess: () => void;
}

const validationSchema = yup.object({
	note: yup.string().notRequired(),
});

const P1MedicalRequestCancel: React.FC<Props> = ({ item, onSuccess }) => {
	const [isLoading, setIsLoading] = useState(false);
	const { showNotificationSuccess } = useNotification();
	const { displayError, displayGQLError } = useApiClient();
	const [deleteMedicalReport] = useCancelP1MedicalRequestMutation();

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = async (values: { note?: string }) => {
		setIsLoading(true);

		try {
			const response = await deleteMedicalReport({
				input: {
					id: item.id,
					note: values.note,
				},
			});

			displayGQLError(response);
			if ('data' in response) {
				showNotificationSuccess({
					content: 'component.p1PMedicalRequestCancel.deleteSuccess',
				});

				onSuccess?.();
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<FormWrapper formMethods={formMethods}>
			<TextAreaField
				name='note'
				label='component.p1PMedicalRequestCancel.cancelationNote'
				isWrapped
			/>
			<SubmitButton
				onSubmit={handleSubmit}
				title='component.p1PMedicalRequestCancel.submitButton'
			/>
		</FormWrapper>
	);
};

export default P1MedicalRequestCancel;
